import clsx from "clsx";
import React from "react";

import {
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { Theme, makeStyles, createStyles } from "@material-ui/core/styles";

export default function CustomerGroupSkeleton() {
  const classes = useStyles();

  const SkeletonButton = ({ className }: { className?: string }) => (
    <Skeleton variant="circle" width={36} height={36} className={className} />
  );

  return (
    <>
      <Grid item>
        <Card className={classes.card}>
          <CardActionArea>
            <CardHeader
              title={
                <Skeleton variant="text" width={120} height={36}></Skeleton>
              }
              subheader={
                <Skeleton variant="text" width={100} height={24}></Skeleton>
              }
              titleTypographyProps={{ variant: "h6" }}
              subheaderTypographyProps={{ variant: "body2" }}
              action={<SkeletonButton />}
            />
            <CardContent className={classes.content} />
          </CardActionArea>
          <CardActions disableSpacing>
            <SkeletonButton />
            <SkeletonButton />
            <SkeletonButton
              className={clsx(classes.skeletonButton, classes.deleteButton)}
            />
          </CardActions>
        </Card>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      minWidth: 220,
      minHeight: "100%",
      backgroundColor: theme.palette.background.default,
    },
    content: {
      height: 40,
    },
    skeletonButton: {
      margin: 8,
    },
    deleteButton: {
      marginLeft: "auto",
    },
  })
);



// WEBPACK FOOTER //
// ./src/components/CustomerGroups/CustomerGroup/CustomerGroupSkeleton.tsx